import nsApi from '@netsapiens/netsapiens-js/dist/api';

export default (params) => new Promise((resolve) => {
  const appLogoData = {
    object: 'image',
    action: 'read',
    server: window.location.hostname,
    filename: 'analytics_header_logo.png',
  };

  if (params && params.domain) appLogoData.domain = params.domain;

  nsApi.getLogo(appLogoData).then((r) => {
    resolve(r);
  }).catch(() => {
    const defaultLogoData = {
      object: 'image',
      action: 'read',
      server: window.location.hostname,
      filename: 'portal_main_top_left.png',
    };

    if (params && params.domain) defaultLogoData.domain = params.domain;

    return nsApi.getLogo(defaultLogoData).then((r) => {
      resolve(r);
    }).catch(() => {
      resolve(false);
    });
  });
});
